import { render } from "./ProductDataList.vue?vue&type=template&id=1c4d0574&scoped=true"
import script from "./ProductDataList.vue?vue&type=script&lang=js"
export * from "./ProductDataList.vue?vue&type=script&lang=js"

import "./ProductDataList.vue?vue&type=style&index=0&id=1c4d0574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4d0574"]])

export default __exports__